import { DropdownMenu, Popover, Slot, Tooltip } from 'radix-ui';
import type { ComponentProps, ReactNode } from 'react';
import { cn } from './cn';

const superficieFlotante =
  'z-50 rounded-[12px] border border-border bg-surface p-1 text-text shadow-[0_12px_32px_-8px_rgb(26_23_24/0.25),0_2px_4px_rgb(26_23_24/0.06)] data-[state=open]:animate-[menu-in_140ms_var(--ease-salida)] origin-(--radix-dropdown-menu-content-transform-origin)';

export const Menu = DropdownMenu.Root;
export const MenuDisparador = DropdownMenu.Trigger;

export function MenuContenido({
  className,
  sideOffset = 6,
  align = 'end',
  ...props
}: ComponentProps<typeof DropdownMenu.Content>) {
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        sideOffset={sideOffset}
        align={align}
        className={cn(superficieFlotante, 'min-w-[200px]', className)}
        {...props}
      />
    </DropdownMenu.Portal>
  );
}

export function MenuItem({
  className,
  peligro,
  icono,
  children,
  ...props
}: ComponentProps<typeof DropdownMenu.Item> & { peligro?: boolean; icono?: ReactNode }) {
  return (
    <DropdownMenu.Item
      className={cn(
        'flex h-9 cursor-pointer items-center gap-2.5 rounded-[8px] px-2.5 text-[14px] outline-none select-none',
        'data-highlighted:bg-surface-muted data-disabled:pointer-events-none data-disabled:opacity-45',
        peligro && 'text-que-strong data-highlighted:bg-que-soft',
        '[&_svg]:size-4 [&_svg]:text-text-2',
        peligro && '[&_svg]:text-que-strong',
        className,
      )}
      {...props}
    >
      {icono}
      {/* With asChild (links) the icon must end up inside the child element. */}
      {props.asChild ? <Slot.Slottable>{children}</Slot.Slottable> : children}
    </DropdownMenu.Item>
  );
}

export function MenuSeparador() {
  return <DropdownMenu.Separator className="my-1 h-px bg-border" />;
}

export function MenuTitulo({ children }: { children: ReactNode }) {
  return (
    <DropdownMenu.Label className="px-2.5 pt-2 pb-1 text-[12px] font-bold tracking-wide text-text-2 uppercase">
      {children}
    </DropdownMenu.Label>
  );
}

export const Globo = Popover.Root;
export const GloboDisparador = Popover.Trigger;
export const GloboAncla = Popover.Anchor;

export function GloboContenido({
  className,
  sideOffset = 6,
  ...props
}: ComponentProps<typeof Popover.Content>) {
  return (
    <Popover.Portal>
      <Popover.Content
        sideOffset={sideOffset}
        className={cn(superficieFlotante, 'p-3', className)}
        {...props}
      />
    </Popover.Portal>
  );
}

/** Tooltip with a short delay; never the only way to learn something. */
export function Ayuda({
  texto,
  children,
  lado = 'top',
}: {
  texto: ReactNode;
  children: ReactNode;
  lado?: 'top' | 'bottom' | 'left' | 'right';
}) {
  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          side={lado}
          sideOffset={6}
          className="z-50 max-w-[260px] rounded-[8px] bg-text px-2.5 py-1.5 text-[13px] leading-snug text-bg shadow-lg data-[state=delayed-open]:animate-[menu-in_120ms_ease-out]"
        >
          {texto}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}

export const ProveedorAyuda = Tooltip.Provider;
